export const isLogin = (state = !!localStorage.getItem('_et'), action) => {
    switch (action.type) {
        case 'IS_LOGIN':
            return action.payload;
        default :
            return state;
    }
};
